<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormUploader
                uploadText="uploadCover"
                fileInputKey="upload_thumbnail"
                :files.sync="formData.thumbnail_list"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                single
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="category"
                placeholder="selectCategory"
                :fieldValue.sync="formData.category"
                :options="categoryOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="8" lg="9">
              <FormInput
                label="title"
                placeholder="title"
                :fieldValue.sync="formData.custom_video_title"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormUploader
                fileInputKey="upload_video"
                :files.sync="formData.video_list"
                :acceptFormat="['vimeo']"
                single
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                required
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          text="delete"
          class="ml-4"
          outlined
          @click="handleDelete()"
          color="error"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormUploader from '@/components/formField/FormUploader.vue'

export default {
  name: 'VideoDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
    FormUploader,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
  },
  data: () => ({
    formData: {
      video_list: [],
      thumbnail_list: [],
      category: null,
      custom_video_title: '',
      video_id: '',
    },
    initVideoId: '',

    categoryOptions: [],
  }),
  methods: {
    async getVideoById() {
      try {
        const data = await this.$Fetcher.GetVideoById(parseInt(this.id))
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        if (this.$validate.DataValid(data.thumbnail)) {
          this.formData.thumbnail_list = [{ name: data.thumbnail, file: data.thumbnail }]
        }
        this.formData.video_list = [
          {
            url: data.video_url,
            name: data.video_title,
            video_id: data.video_id,
            file: null,
            is_vimeo: true,
          },
        ]
        this.initVideoId = data.video_id
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'VideoList',
          })
        }
      }
    },

    // -- (確認)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        // create tutorial video
        const payload = {
          category: this.formData.category,
          video_id: this.formData.video_list[0]?.video_id || '',
          custom_video_title: this.formData.custom_video_title,
          thumbnail: this.formData.thumbnail_list.length ? this.formData.thumbnail_list[0].file : '',
        }
        if (!this.$validate.DataValid(payload['video_id'])) {
          throw 'message.errorOccur'
        } else {
          if (this.$validate.DataValid(this.id)) {
            await this.$Fetcher.UpdateVideo(this.id, payload)
          } else {
            await this.$Fetcher.NewVideo(payload)
          }
          // remove unused uploaded vimeo before leave
          this.formData.video_id = payload.video_id
          // delete old video
          if (this.$validate.DataValid(this.initVideoId) && this.initVideoId !== payload.video_id) {
            this.$store.dispatch('insertRemovedVimeoVideoID', this.initVideoId)
          }
          await this.removeVimeo()

          // alert success
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
            refresh: this.$validate.DataValid(this.id),
            redirect: !this.$validate.DataValid(this.id) ? 'VideoList' : null,
          })
        }
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        let msg = err
        let logout = false;
        switch (err) {
          case 'invalid access token':
          case 'refresh token expired':
          case 'invalid refresh token':
          case 'invalid refresh token payload':
          case 'not a refresh token':
          case 'invalid access token payload':
          case 'not a access token':
          case 'access token and refresh token is not a pair':
          case 'value missing':
            logout = true;
            msg = `${this.$t('message.loginExpired')} (${err.toUpperCase()})`
            break
          default:
            if (typeof err !== 'string' && err !== null) {
              msg = JSON.stringify(err)
            }
        }
        this.showAlert({
          title: 'message.saveFail',
          message: msg,
          isError: true,
          returnLink: logout ? 'Login' : null
        })
      }
    },
    async removeVimeo() {
      let removeList = [...this.$store.getters.removedVimeoVideoIDList]
      removeList = removeList.filter(el => el !== this.formData.video_id)
      return await this.removeUnusedVimeoVideo(removeList)
    },

    // -- (刪除)
    async handleDelete() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteVideo(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'VideoList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ======== 類別 Options =======
    async getCategoryOptions() {
      try {
        let payload = {}
        const { data } = await this.$Fetcher.GetVideoCategories(payload)
        this.categoryOptions = data.map(el => {
          return {
            value: el.id,
            text: el.name,
          }
        })
      } catch {}
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: VideoDetails')
      await this.getCategoryOptions()

      if (this.$validate.DataValid(this.id)) {
        await this.getVideoById()
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  async destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  async beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      // remove unused vimeo before leave
      await this.removeVimeo()
      next()
    }
  },
}
</script>
